// src/admin/pages/Dashboard/AdminDashboard.js
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";

import DashboardSidebar from "./DashboardSidebar";
import MobileFooterMenu from "./MobileFooterMenu";

import OrdersPage from "./OrdersPage";
import KpiPage from "./KpiPage";
import DishesPage from "./DishesPage";
import AIPage from "./AIPage";
import ProcessesPage from "./ProcessesPage";
import InventoryPage from "./InventoryPage";

export default function AdminDashboard() {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <div style={styles.container}>
      {/* Sidebar se non siamo su mobile */}
      {!isMobile && <DashboardSidebar />}

      <main style={styles.mainContent}>
        <h1></h1>
        <Routes>
          {/* Se il path "locale" è "/", reindirizza a "orders". 
              Il risultato assoluto sarà /admin/dashboard/kpi */}
          <Route path="/" element={<Navigate to="kpi" replace />} />

          {/* Rotte interne (figlie) -> /admin/dashboard/orders, /admin/dashboard/kpi, ecc. */}
          <Route path="orders" element={<OrdersPage />} />
          <Route path="kpi" element={<KpiPage />} />
          <Route path="piatti" element={<DishesPage />} />
          <Route path="ai" element={<AIPage />} />
          <Route path="processi" element={<ProcessesPage />} />
          <Route path="inventory" element={<InventoryPage />} />
        </Routes>
      </main>

      {/* Footer se siamo su mobile */}
      {isMobile && <MobileFooterMenu />}
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    minHeight: "100vh",
  },
  mainContent: {
    flex: 1,
    padding: "1rem",
    marginBottom: "60px", // Spazio per eventuale footer
  },
};
